import type { User } from '@fluenceur/types';

export type PendingLegalDocument = 'cgu' | 'privacy' | 'cgv';

/** Older API responses requested the two general legal documents together. */
export function pendingLegalDocuments(user: User | null | undefined): PendingLegalDocument[] {
  return user?.pendingLegalDocuments ?? ['cgu', 'privacy'];
}

export const LEGAL_DOCUMENT_LABELS = {
  cgu: 'legal.modal.termsOfUse',
  privacy: 'legal.modal.privacyPolicy',
  cgv: 'legal.modal.termsAndConditions',
} as const;
